(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfx-photo-gallery"] && !Shopify.designMode) return;
  try {
    
  class PhotoGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;

      this.tiles = Array.from(this.querySelectorAll('[data-slide]'));
      this.arrows = this.querySelector('[data-arrows]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      this.ticking = false;

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.prevBtn?.addEventListener('click', () => this.scrollByTile(-1), { signal });
      this.nextBtn?.addEventListener('click', () => this.scrollByTile(1), { signal });
      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true, signal });
      window.addEventListener('resize', () => this.update(), { passive: true, signal });

      this.update();
    }

    // One tile + gap, measured from the first two tiles (correct at any width).
    step() {
      const [a, b] = this.tiles;
      if (a && b) return b.getBoundingClientRect().left - a.getBoundingClientRect().left;
      return a ? a.getBoundingClientRect().width : 0;
    }

    scrollByTile(direction) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * this.step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const overflowing = max > 1;

      // Hide the whole control when everything fits (e.g. three tiles on desktop).
      if (this.arrows) this.arrows.hidden = !overflowing;
      if (!overflowing) return;

      const x = this.track.scrollLeft;
      if (this.prevBtn) this.prevBtn.disabled = x <= 1;
      if (this.nextBtn) this.nextBtn.disabled = x >= max - 1;
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  if (!customElements.get('photo-gallery')) {
    customElements.define('photo-gallery', PhotoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      // Close any open hotspot popover on scroll so it doesn't drift from its marker.
      if (this.querySelector('kit-popover')) {
        window.addEventListener(
          'scroll',
          () => {
            this.querySelectorAll('kit-popover:popover-open').forEach((p) => p.hidePopover());
          },
          { passive: true, signal }
        );
      }

      if (!Shopify.designMode) return;

      // In the theme editor, open a hotspot's popover when its block is selected.
      this.addEventListener(
        'shopify:block:select',
        (event) => {
          const btn = event.target.querySelector('button');
          if (btn) btn.click();
        },
        { signal }
      );

      this.addEventListener(
        'shopify:block:deselect',
        (event) => {
          const popover = event.target.querySelector('kit-popover');
          if (popover) popover.hidePopover?.();
        },
        { signal }
      );
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
